import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Badge, Breadcrumb, Button, Col, Row } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import copy from 'copy-to-clipboard';
import { getRequest, putRequest } from '../../../helpers/apiHandler';
import AddAPIKeysModal from '../../../components/AccountSetting/APIMessage/AddAPIKeysModal';
import config from '../../../config/Constant';
import CustomAlert from '../../../components/CustomAlert';

// const baseUrl = process.env.PUBLIC_URL;

const APIMessage = ({ access_token }) => {
  const [onLoading, setOnLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [data, setData] = useState([]);
  const [detail, setDetail] = useState({});
  const [page, setPage] = useState({
    totalKeys: 0,
    totalPages: 0,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [formType, setFormType] = useState('add');
  const [alertState, setAlertState] = useState({
    show: false,
    variant: 'danger',
    message: '',
  });

  const getAPIKeysData = () => {
    setOnLoading(true);
    const data = {
      headers: {
        Authorization: access_token.token,
      },
      params: {
        page: currentPage,
        limit: perPage,
      },
    };

    getRequest('/api-key', data, (res) => {
      if (!res.error) {
        setData(res.data);
      } else {
        setAlertState({
          message: res.message,
          show: true,
          variant: 'danger',
        });
      }
      setOnLoading(false);
    });
  };

  const onClickStatusKey = (id, status) => {
    const data = {
      status: status === 1 ? 2 : 1,
    };

    putRequest(`/api-key/${id}`, data, access_token.token, (res) => {
      if (!res.error) {
        setAlertState({
          message: 'Your changes have successfully been saved!',
          show: true,
          variant: 'success',
        });
        getAPIKeysData();
      } else {
        setAlertState({
          message: res.message,
          show: true,
          variant: 'danger',
        });
      }
    });
  };

  const onClickAdd = () => {
    setShowModal(true);
    setFormType('add');
  };

  const onClickEdit = (rowData) => {
    setShowModal(true);
    setFormType('edit');
    setDetail(rowData);
  };

  const onPageChange = (page) => {
    setCurrentPage(page);
    getAPIKeysData();
  };

  const onPerRowsChange = (currentRowsPerPage, currentPage) => {
    setCurrentPage(currentPage);
    setPerPage(currentRowsPerPage);
    getAPIKeysData();
  };

  const onClickCopy = (row) => {
    copy(row.token);
    setAlertState({
      message: 'Copied to clipboard!',
      show: true,
      variant: 'success',
    });
  };

  useEffect(() => {
    getAPIKeysData();
  }, []);

  useEffect(() => {
    if (alertState.show) {
      setTimeout(() => {
        setAlertState({
          message: '',
          show: false,
          variant: '',
        });
      }, config.notify_time);
    }
  }, [alertState]);

  const columns = [
    {
      name: 'Status',
      sortable: true,
      width: '150px',
      selector: (row) => (
        <Badge variant={row.status === 1 ? 'success' : 'danger'}>
          {row.status === 1 ? 'Active' : 'Inactive'}
        </Badge>
      ),
    },
    {
      name: 'Name',
      sortable: true,
      width: '200px',
      selector: (row) => row.name,
    },
    {
      name: 'Description',
      sortable: true,
      width: '200px',
      selector: (row) => row.description,
    },
    {
      name: 'API Key',
      sortable: true,
      width: '200px',
      selector: (row) => (
        <div className="token-fieldarea">
          <span
            role="button"
            tabIndex={0}
            onClick={() => onClickCopy(row)}
            className='token-text'
          >
            {row.token}
          </span>
          <Button variant="link" size="sm" onClick={() => onClickCopy(row)}>
            <i className="fa fas fa-copy" />
          </Button>
        </div>
      ),
    },
    {
      name: 'Options',
      minWidth: '360px',
      selector: (row) => (
        <div className="d-flex justify-content-center align-items-center gap-1">
          <Button
            variant="ghost"
            onClick={() => onClickStatusKey(row.id, row.status)}
            style={{ minWidth: 100 }}
          >
            {row.status === 1 ? 'Deactivate' : 'Activate'}
          </Button>
          <Button variant="ghost" onClick={() => onClickEdit(row)} style={{ minWidth: 100 }}>
            Edit
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div className="w-100" style={{ padding: 30 }}>
      <div className="page-heading" style={{ padding: "24px 40px" }}>
        <div className="container-left" style={{ marginBottom: "16px"}}>
          <div className="page-title">API Keys</div>
        </div>
        <div className="container-right">
          <Button
            variant="ghost"
            href="https://a2p.elfo.com/apis-docs"
            target="_blank"
            rel="noopener noreferrer"
          >
            API Documentation
          </Button>
          <Button
            variant="primary"
            className="d-flex align-items-center justify-content-center"
            onClick={onClickAdd}
            style={{ gap: 10, minWidth: 160 }}
          >
            <i className="fas fa-plus" />
            Create API Key
          </Button>
        </div>
        <p>Send SMS and import contacts using elfoA2P APIs.</p>
      </div>
      <CustomAlert
        message={alertState.message}
        show={alertState.show}
        variant={alertState.variant}
        closeAlert={() => setAlertState({ show: false, variant: 'danger', message: '' })}
      />
      <div className="APIKeysCard">
        <DataTable
          columns={columns}
          data={data}
          className="custom-datatable"
          paginationComponentOptions={{
            rowsPerPageText: 'Items per page:',
          }}
          pagination
          paginationServer
          paginationPerPage={perPage}
          paginationTotalRows={page.totalKeys}
          onChangeRowsPerPage={onPerRowsChange}
          onChangePage={onPageChange}
        />
      </div>
      <AddAPIKeysModal
        show={showModal}
        onClose={() => {
          setShowModal(false);
          setFormType('add');
        }}
        activeKey={detail}
        fromEdit={formType === 'edit'}
        fromAdd={formType === 'add'}
        getAPIKeysData={getAPIKeysData}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  const { access_token } = state.auth;

  return { access_token };
};

export default connect(mapStateToProps)(APIMessage);
